/* Hand-written GraphQL documents for ExecQuotePricing (CONF-106 part 3).
   Mirrors catalogOps.js; regenerate/replace if codegen is re-run. */

export const createExecQuotePricing = /* GraphQL */ `
  mutation CreateExecQuotePricing($input: CreateExecQuotePricingInput!) {
    createExecQuotePricing(input: $input) {
      id quoteId overrideSetId vendor quarter createdAt
    }
  }
`;

export const getExecQuotePricing = /* GraphQL */ `
  query GetExecQuotePricing($id: ID!) {
    getExecQuotePricing(id: $id) {
      id quoteId overrideSetId vendor quarter basisSnapshot overrides
      actorEmail actorSub appVersion createdAt
    }
  }
`;
